import { Box, H3, HStack, Link, Separator, Text, VStack } from '@betterment/samba-react';

import { SupportCardShimmer } from './LoadingSupportCard';

import type { SupportContact } from '~/graphql/schema';

export type Props = {
  contacts?: Array<SupportContact>;
};

export const SupportContacts = ({ contacts }: Props) => (
  <VStack
    css={{
      gap: 'space.400',
    }}
  >
    {!contacts ? (
      <SupportCardShimmer />
    ) : (
      contacts.map(contact => (
        <Box key={contact.title} aria-label={contact.title} role="group">
          <Separator />
          <HStack
            css={{
              gap: 'space.500',
              mt: 'space.400',
            }}
          >
            <Box
              css={{
                flex: 1,
              }}
            >
              <H3 color="text" variant="title100">
                {contact.title}
              </H3>
              <Text as="span" color="text.weak" variant="text50">
                {contact.description}
              </Text>
            </Box>
            <VStack
              css={{
                flex: 1,
                alignItems: 'flex-start',
                gap: 'space.50',
              }}
            >
              {contact.name && <Text as="p">{contact.name}</Text>}
              {contact.phoneNumber && (
                <Text as="p">
                  {contact.phoneNumber}
                  {contact.availableHours && (
                    <>
                      <br />
                      <Text as="span" variant="text50" css={{ marginTop: 0 }}>
                        {contact.availableHours}
                      </Text>
                    </>
                  )}
                </Text>
              )}
              {contact.calendlyUrl && <Link href={contact.calendlyUrl}>Schedule a call</Link>}
              {contact.email && <Link href={`mailto:${contact.email}`}>{contact.email}</Link>}
            </VStack>
          </HStack>
        </Box>
      ))
    )}
  </VStack>
);
